<template >
  <div style="height: 14px;"
       class="ti_bg"></div>
</template>

<script>
  export default {
    name: 'TitleUnderline'
  }
</script>

<style scoped>

</style>
